module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteBudgetDialog.events.successfulDeletion":"Successfully deleted the budget \u0027{name}\u0027","deleteBudgetDialog.title":"Delete Budget","deleteBudgetDialog.subtitle":"Please enter the name of this budget to delete it"}}')
  delete Component.options._Ctor
}
